import { AgeTarget, Canton, DigitalAdChannel, HouseholdSizeTarget, IncomeTarget } from '@/services/ws-post/src/main/resources/rest-api';

import { Step } from 'src/modules/PostCampaign';
import type { PostDigitalAdChannel } from './types';

export const AGE_NUMERIC = {
  [AgeTarget.ZERO]: 0,
  [AgeTarget.FIVE]: 5,
  [AgeTarget.TEN]: 10,
  [AgeTarget.FIFTEEN]: 15,
  [AgeTarget.TWENTY]: 20,
  [AgeTarget.TWENTY_FIVE]: 25,
  [AgeTarget.THIRTY]: 30,
  [AgeTarget.THIRTY_FIVE]: 35,
  [AgeTarget.FORTY]: 40,
  [AgeTarget.FORTY_FIVE]: 45,
  [AgeTarget.FIFTY]: 50,
  [AgeTarget.FIFTY_FIVE]: 55,
  [AgeTarget.SIXTY]: 60,
  [AgeTarget.SIXTY_FIVE]: 65,
  [AgeTarget.SEVENTY]: 70,
  [AgeTarget.SEVENTY_FIVE]: 75,
  [AgeTarget.EIGHTY]: 80,
  [AgeTarget.EIGHTY_FIVE]: 85,
  [AgeTarget.NINETY]: 90,
  [AgeTarget.NINETY_PLUS]: 95,
};

export const INCOME_NUMERIC: Record<IncomeTarget, number> = {
  [IncomeTarget.ZERO]: 0,
  [IncomeTarget.TWENTY_FIVE]: 25,
  [IncomeTarget.FORTY]: 40,
  [IncomeTarget.SIXTY]: 60,
  [IncomeTarget.EIGHTY]: 80,
  [IncomeTarget.ONE_HUNDRED]: 100,
  [IncomeTarget.ONE_HUNDRED_FIFTY]: 150,
  [IncomeTarget.THREE_HUNDRED]: 300,
  [IncomeTarget.TREE_HUNDRED_PLUS]: 350,
};

export const HOUSEHOLD_SIZE_NUMERIC = {
  [HouseholdSizeTarget.ONE]: 1,
  [HouseholdSizeTarget.TWO]: 2,
  [HouseholdSizeTarget.THREE]: 3,
  [HouseholdSizeTarget.FOUR]: 4,
  [HouseholdSizeTarget.FIVE]: 5,
  [HouseholdSizeTarget.SIX]: 6,
};

export const RADIUS_MAX = 175;
export const DRIVING_MINUTES_MIN = 1;
export const DRIVING_MINUTES_MAX = 60;

export const DIGITAL_AD_CHANNELS: PostDigitalAdChannel[] = [
  DigitalAdChannel.SCREENS_PUBLIC_TRANSPORT,
  DigitalAdChannel.SCREENS_CITY,
  DigitalAdChannel.SCREENS_RETAIL,
  DigitalAdChannel.SCREENS_IN_STORE,
  DigitalAdChannel.SCREENS_GAS_STATION,
];

export const DEFAULT_POST_CODE_EXTENSION = '00';

export const CANTON_ITEMS = Object.values(Canton);

const basePath = '/orders/post-campaigns/:status/:campaignId';

export const STEP_PATH = {
  edit: `${basePath}/edit`,
  information: `${basePath}/information`,
  targetGroupSettings: `${basePath}/target-group-settings/:targetGroupId?`,
  calculation: `${basePath}/calculation`,
  editPositions: `${basePath}/edit-positions/:positionType?`,
  documentPreview: `${basePath}/document-preview`,
} as const;

export const REGULAR_CELL_PADDING = '8px';
export const HEADER_CELL_PADDING = '16px 8px';
export const LOADER_CELL_PADDING = '9px 8px';

export const PLACEHOLDER = '—';

export const STEPS: Step[] = [
  Step.GENERAL,
  Step.INFORMATION,
  Step.TARGET_GROUP_SETTINGS,
  Step.CALCULATION,
  Step.CONFIGURE_POSITIONS,
  Step.PREVIEW,
];

export const MIN_WEIGHT = 1;
export const MAX_STANDARD_MAILING_WEIGHT = 100;
export const MIN_MEDIUM_MAILING_WEIGHT = MAX_STANDARD_MAILING_WEIGHT + 1;
export const MAX_MEDIUM_MAILING_WEIGHT = 500;
export const MAX_LARGE_MAILING_WEIGHT = 1000;
